import React from "react";
import { Link } from "react-router-dom";
import {
  resolveMediaUrl,
  handleMediaImgError,
} from "../../Helper/mediaUrl";
import { buildEntityLibrarySections } from "./entityVideoDisplayOrder";

/**
 * Canonical public entity video library (Org / Creator / Project).
 * Subcategory-first when video_subcategories are present; otherwise direct
 * videos newest-first. No entity-specific hard-coding — presentation follows
 * payload data only.
 */
function EntityPublicVideoLibrary({
  videos,
  videoSubcategories,
  onPlayVideo,
  keyPrefix = "entity",
  emptyLabel = "No videos published yet.",
  regionLabel = "Latest videos",
}) {
  const sections = buildEntityLibrarySections({
    videos,
    video_subcategories: videoSubcategories,
  });
  const cards = [];

  sections.subcategoryCards.forEach((sub) => {
    const path = (sub && sub.path) || `/sub-category/${sub.id}`;
    const image = sub && (sub.image || sub.thumbnail);
    cards.push(
      <Link
        key={`${keyPrefix}-sub-${sub.id}`}
        to={path}
        className="org-video-card org-video-carousel__item org-video-card--subcategory"
      >
        <div className="org-video-card__media relative">
          {image ? (
            <img
              src={resolveMediaUrl(image)}
              alt={sub.name || ""}
              className="org-video-card__thumb"
              onError={handleMediaImgError}
              loading="lazy"
            />
          ) : (
            <div className="org-video-card__thumb org-subcategory-placeholder">
              <span className="org-subcategory-placeholder__label">
                {sub.name || "Subcategory"}
              </span>
            </div>
          )}
        </div>
        <div className="org-video-title">{sub.name}</div>
      </Link>
    );
  });

  sections.directVideos.forEach((video) => {
    cards.push(
      <Link
        key={`${keyPrefix}-video-${video.id}`}
        to="#"
        className="org-video-card org-video-carousel__item"
        onClick={(event) => {
          if (typeof onPlayVideo === "function") {
            onPlayVideo(event, video.id);
          }
        }}
      >
        <div className="org-video-card__media relative">
          {video.image ? (
            <img
              src={resolveMediaUrl(video.image)}
              alt={video.title || ""}
              className="org-video-card__thumb"
              onError={handleMediaImgError}
              loading="lazy"
            />
          ) : (
            <div className="org-video-card__thumb org-video-card__thumb--empty" />
          )}
          <div className="trailers-img-overlay">
            <div className="thumbslider-outline">
              <i className="fas fa-play" />
            </div>
          </div>
        </div>
        <div className="org-video-title">{video.title}</div>
      </Link>
    );
  });

  if (!cards.length) {
    return <p className="org-empty-inline cstudio-muted">{emptyLabel}</p>;
  }

  return (
    <div
      className="org-video-carousel"
      role="region"
      aria-label={regionLabel}
    >
      <div className="org-video-carousel__track">{cards}</div>
    </div>
  );
}

export default EntityPublicVideoLibrary;
